/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */

window.PXUTheme.jsAjaxCart = {
  init: function ($section) {

    window.PXUTheme.jsAjaxCart = $.extend(this, window.PXUTheme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document)
        .off('click.jsAjaxCart', '[data-ajax-cart-trigger]')
        .on('click.jsAjaxCart', '[data-ajax-cart-trigger]', function (e) {
          e.preventDefault();
          window.PXUTheme.jsAjaxCart.showDrawer();
          return false;
        });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document)
      .off('click.jsAjaxCart', '.ajax-submit')
      .on('click.jsAjaxCart', '.ajax-submit', function (e) {
        e.preventDefault();
        const $addToCartForm = $(this).closest('form');
        window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);
        return false;
      });

    $(document)
      .off('click.jsAjaxCart', '[data-ajax-cart-delete]')
      .on('click.jsAjaxCart', '[data-ajax-cart-delete]', function (e) {
        e.preventDefault();
        const lineID = $(this).parents('[data-line-item]').data('line-item');
        window.PXUTheme.jsAjaxCart.removeFromCart(lineID);

        if (window.PXUTheme.jsCart) {
          window.PXUTheme.jsCart.removeFromCart(lineID);
        }

        return false;
      });

   $(document)
    .off('click.jsAjaxCart', '[data-ajax-cart-close]')
    .on('click.jsAjaxCart', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      window.PXUTheme.jsAjaxCart.hideDrawer();
      window.PXUTheme.jsAjaxCart.hideMiniCart();
      return false;
    });

  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(window.PXUTheme.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
  },
  removeFromCart: function (lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        window.PXUTheme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  initializeAjaxCart: function () {
    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url,
      'ajax',
    )
      .done(({ html, options }) => {
        $('[data-ajax-cart-content]').html(html.content);
        if (window.PXUTheme.currencyConverter) {
          window.PXUTheme.currencyConverter.convertCurrencies();
        }
      })
      .fail(() => {});
  },
  initializeAjaxCartOnMobile: function () {
    this.toggleMiniCart();
    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url,
      'ajax',
    )
      .done(({ html, options }) => {
        $('.mobile-header [data-ajax-cart-content]').html(html.content);
      })
      .fail(() => {});
  },
  showStockWarning: function ($form, msg) {
    let $w = $form.find('.bv-stock-warning');
    if (!$w.length) {
      $form.find('.button--add-to-cart').after('<p class="bv-stock-warning"></p>');
      $w = $form.find('.bv-stock-warning');
    }
    $w.text(msg);
  },
  clearStockWarning: function ($form) {
    $form.find('.bv-stock-warning').remove();
  },
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');
    this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');

    const input = $addToCartForm.find('.quantity-input').last()[0];
    const step = parseInt(input ? input.dataset.step : 1, 10) || 1;

    if (input && (!input.value || parseInt(input.value, 10) < step)) {
      input.value = step;
    }

    const variantId = $addToCartForm.find('[name="id"]').val();
    const self = this;

    const proceed = function() {
      self.clearStockWarning($addToCartForm);

      if (self.recipientForm) {
        self.recipientForm.classList.remove('recipient-form--has-errors');
      }

      $addToCartForm.removeClass('shopify-product-form--unselected-error');

      if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
        const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

        $('.warning').remove();

        $addToCartForm
          .addClass('shopify-product-form--unselected-error')
          .find('.cart-warning')
          .html(cartWarning);

        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
        $addToCartBtn.find('.icon').removeClass('zoomOut').addClass('zoomIn');
        $addToCartBtn.find('span:not(.icon)').text($addToCartBtn.data('label')).removeClass('zoomOut').addClass('zoomIn');

      } else {
        $.ajax({
          url: '/cart/add.js',
          dataType: 'json',
          cache: false,
          type: 'post',
          data: $addToCartForm.serialize(),
          beforeSend: function () {
            $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
            $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
          },
          success: function (product) {
            let $el = $('[data-ajax-cart-trigger]');

            $addToCartBtn.find('.checkmark').addClass('checkmark-active');

            function addedToCart() {
              if (!isScreenSizeLarge()) {
                $el = $('.mobile-header [data-ajax-cart-trigger]');
                window.PXUTheme.scrollToTop($el);
              } else {
                $el = $('[data-ajax-cart-trigger]');
              }
              $el.addClass('show-mini-cart');
              $addToCartBtn.find('span').removeClass('fadeInDown');
            }

            window.setTimeout(function () {
              $addToCartBtn.removeAttr('disabled').removeClass('disabled');
              $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
              $addToCartBtn.find('.text, .icon').removeClass('zoomOut').addClass('fadeInDown');
              $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);
            }, 1000);

            window.PXUTheme.jsAjaxCart.showDrawer();
            window.PXUTheme.jsAjaxCart.updateView();

            if (window.PXUTheme.jsCart) {
              $.ajax({
                dataType: 'html',
                async: false,
                cache: false,
                url: "/cart",
                success: function (html) {
                  const cartForm = $(html).find('.cart__form');
                  $('.cart__form').replaceWith(cartForm);
                }
              });
            }
          },
          error: function(XMLHttpRequest) {
            const response = eval('(' + XMLHttpRequest.responseText + ')');

            $('.warning').remove();

            let cartWarning;

            if (response.errors && response.errors.email) {
              self.recipientForm.classList.add('recipient-form--has-errors');
            } else {
              cartWarning = `<p class="cart-warning__message animated bounceIn">${response.description.replace('All 1 ', 'All ')}</p>`;
            }

            $addToCartForm.find('.cart-warning').html(cartWarning);
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.icon').removeClass('zoomOut').addClass('zoomIn');
            $addToCartBtn.find('span:not(.icon)').text($addToCartBtn.data('label')).removeClass('zoomOut').addClass('zoomIn');
          }
        });
      }
    };

    if (variantId) {
      fetch('/variants/' + variantId + '.js')
        .then(function(r) { return r.json(); })
        .then(function(inventoryData) {
          if (
            inventoryData.inventory_management === 'shopify' &&
            inventoryData.inventory_policy === 'deny' &&
            inventoryData.inventory_quantity < step
          ) {
            self.showStockWarning($addToCartForm, 'Not enough stock — only ' + inventoryData.inventory_quantity + ' available, minimum order is ' + step + '.');
            return; // block — do not call proceed
          }
          proceed();
        })
        .catch(function() {
          proceed(); // if fetch fails, don't block
        });
    } else {
      proceed();
    }
  },
  updateView: function () {
    window.PXUTheme.asyncView.load(
      window.PXUTheme.routes.cart_url,
      'ajax',
    )
    .done(({ html, options }) => {
      if (options.item_count > 0) {
        const itemList = $(html.content).find('.ajax-cart__list');
        const cartDetails = $(html.content).find('.ajax-cart__details-wrapper');

        $('.ajax-cart__list').replaceWith(itemList);
        $('.ajax-cart__details-wrapper').replaceWith(cartDetails);
        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);
      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      setTimeout(() => {
        if (window.PXUTheme.variantQuantityHandler) {
        }
      }, 50);

      if (window.PXUTheme.currencyConverter) {
        window.PXUTheme.currencyConverter.convertCurrencies();
      }
    })
    .fail(() => {});
  },
  unload: function ($section) {
    $(document).off('click.jsAjaxCart', '.ajax-submit');
    $(document).off('click.jsAjaxCart', '[data-ajax-cart-delete]');
    $(document).off('click.jsAjaxCart', '[data-ajax-cart-close]');
    $(document).off('click.jsAjaxCart', '[data-ajax-cart-trigger]');
  }
}

/******/ })();

